import React from "react";
import { CircleFlag } from "../../common/CircleFlag";
import { TeamInfo } from "../MobileCreationWizard/steps/PreferencesStep";
import CheckRoundedIcon from "@mui/icons-material/CheckRounded";
import "./styles.scss";

interface TeamTileSmallProps {
  name: string;
  countryCode: string;
  /** Highlights the tile (gold ring + check) when this team is already picked. */
  selected?: boolean;
  onTeamClick: (chosenTeam: TeamInfo) => void;
}

const TeamTileSmall: React.FC<TeamTileSmallProps> = ({
  countryCode,
  name,
  selected = false,
  onTeamClick,
}) => {
  return (
    <button
      type="button"
      className={`teamTileSmall__root${
        selected ? " teamTileSmall__root--selected" : ""
      }`}
      aria-pressed={selected}
      onClick={() => onTeamClick({ name, countryCode })}
    >
      <span className="teamTileSmall__flagBox">
        <CircleFlag
          countryCode={countryCode}
          height={45}
          width={45}
          className="teamTileSmall__flag"
        />
        {selected && <CheckRoundedIcon className="teamTileSmall__check" />}
      </span>
      <span className="teamTileSmall__name">{name}</span>
    </button>
  );
};

export default TeamTileSmall;
